/**
 * The one thing a Hiring Manager sees on their first dashboard visit after
 * activating: a single dismissible line naming the customer they're set up
 * to review for. Deliberately not an onboarding tour or wizard -- either
 * would undercut the "light" activation experience the SSO-first flow is
 * built around.
 *
 * Which visit is "first" is decided by the caller (Dashboard reads a
 * `?welcome=` query param set by the activation redirect, then strips it),
 * not by this component -- it only knows how to render and how to signal
 * dismissal.
 */

import { memo } from 'react';
import { Alert } from 'antd';
import styles from './index.module.css';

export interface WelcomeNoteProps {
  customerName: string;
  onDismiss: () => void;
}

export const WelcomeNote = memo(
  ({ customerName, onDismiss }: WelcomeNoteProps) => (
    <Alert
      type="info"
      showIcon
      closable
      onClose={onDismiss}
      message={`You're set up to review candidates for ${customerName}.`}
      className={styles.note}
    />
  ),
);

WelcomeNote.displayName = 'WelcomeNote';

export default WelcomeNote;
